/**
 * @generated SignedSource<<723a3385856f6793a174c15081fa5d04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "includeWhoamiNext"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v2 = [
  {
    "condition": "includeWhoamiNext",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "whoamiNext",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Vibe",
            "kind": "LinkedField",
            "name": "vibe",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "graphqlWhoamiNextConditionalQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlWhoamiNextConditionalQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "48044f666ab101301484db89921fdd37",
    "id": null,
    "metadata": {},
    "name": "graphqlWhoamiNextConditionalQuery",
    "operationKind": "query",
    "text": "query graphqlWhoamiNextConditionalQuery(\n  $includeWhoamiNext: Boolean = true\n) {\n  whoamiNext @include(if: $includeWhoamiNext) {\n    id\n    username\n    email\n    version\n    vibe {\n      username\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c537637b234f0f048fef002db5fe15de";

module.exports = node;
